// extracted by mini-css-extract-plugin
export var colorAthens = "#dbdce6";
export var colorBlack = "#0c1112";
export var colorDanube = "#679ac9";
export var colorIce = "#cee8f3";
export var colorMidnight = "#121540";
export var colorMilk = "#fffbf5";
export var colorMulberry = "#4d3c6e";
export var colorNightshadz = "#b23e3e";
export var colorPensive = "#84869a";
export var colorPort = "#2f214e";
export var colorShark = "#2b2c33";
export var colorSky = "#9ac8e5";
export var colorVoodoo = "#4e395e";
export var colorWhite = "#fff";
export var colorYonder = "#556ba1";